import React from 'react'
import "./VirtualRealityPage.css";
import Navbar from "../components/Navbar";
const SpatialViewer = () => {
  return (
    <>
      <Navbar />
      <div className="page-container">
        {/* <h5 className="page-title">Virtual & Augmented/Mixed Reality</h5>
        <p>Welcome to our spatial technology solutions for AR, VR, and MR!</p> */}
        <p className="coming-soon">Coming soon...</p>
      </div>
    </>
  )
}

export default SpatialViewer
